import React, { useEffect, useState } from "react";
import { useCart } from "react-use-cart";
import { useLocation, useParams, Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import axios from "axios";
import API_URL from "../../ApiUrl";
import { FormatRupiah } from "./services/FormatRupiah";
import Cart from "./Cart";
import ReactImageZoom from "react-image-zoom";
import "./merchandisedetail.css";

const MerchandiseDetail = () => {
  const location = useLocation();
  const { addItem, inCart, items, emptyCart } = useCart();
  const [showCart, setShowCart] = useState(false);
  const empty_cart = location.state?.empty_cart;
  const { code_product } = useParams();
  const [produk, setProduk] = useState(null);
  const [loading, setLoading] = useState(true);
  const [images, setImages] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });
  const [zoomEnabled, setZoomEnabled] = useState(true);
  const [addedAnim, setAddedAnim] = useState(false);

  useEffect(() => {
    fetchProduk(code_product);
  }, [code_product]);

  const fetchProduk = async (code_product) => {
    try {
      const response = await axios.get(
        `${API_URL.superStudent}/api/v1/application/niec-merchandise/produk-detail/${code_product}`
      );
      const data = response.data;
      setProduk(data);

      const imagesArray = [];
      if (data.file_pic != null) imagesArray.push(data.file_pic);
      if (data.file_pic1 != null) imagesArray.push(data.file_pic1);
      if (data.file_pic2 != null) imagesArray.push(data.file_pic2);
      if (data.file_pic3 != null) imagesArray.push(data.file_pic3);

      setImages(imagesArray);
      setLoading(false);
    } catch (error) {
      console.error("Data Tidak Masuk:", error);
      setLoading(false);
    }
  };

  const handleAddToCart = (produk) => {
    addItem(produk);
    setAddedAnim(true);
    setTimeout(() => setAddedAnim(false), 600);
  };

  const handleImageChange = (index) => {
    setCurrentImageIndex(index);
    setCursorPosition({ x: 0, y: 0 });
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
        <div className="spinner-border text-danger" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  const settings = {
    customPaging: function (i) {
      return (
        <a>
          <img src={images[i]} alt={`thumbnail-${i}`} />
        </a>
      );
    },
    dots: true,
    dotsClass: "slick-dots slick-thumb",
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: handleImageChange,
  };

  return (
    <section className="mdetail-page-wrapper">
      <div className="container">
        <Link to="/merchandise" className="mdetail-back-btn">
          <i className="bi bi-arrow-left"></i> Kembali ke Merchandise
        </Link>

        <div className="mdetail-card animate__animated animate__fadeInUp">
          {/* Gallery */}
          <div className="mdetail-gallery">
            <Slider
              {...settings}
              beforeChange={() => setZoomEnabled(false)}
              afterChange={() => setZoomEnabled(true)}
            >
              {images.map((image, index) => (
                <div key={index}>
                  <div
                    className="mdetail-main-img-wrapper"
                    style={{ position: "relative", width: "100%", maxWidth: "540px", margin: "0 auto", overflow: "hidden" }}
                  >
                    {zoomEnabled && (
                      <ReactImageZoom
                        img={image}
                        zoomScale={1.5}
                        width={540}
                        height={306}
                        isZoomed={false}
                        zoomPosition="original"
                        zoomType="hover"
                        cursorOnset={cursorPosition}
                      />
                    )}
                  </div>
                </div>
              ))}
            </Slider>
          </div>

          {/* Info */}
          <div className="mdetail-info">
            <div className="mdetail-badge-row">
              <span className="mdetail-badge">Made In Indonesia</span>
              <span className="mdetail-badge condition">Kondisi: Baru</span>
            </div>

            <h1 className="mdetail-title">{produk.name_product}</h1>

            <div className="mdetail-price-box">
              <h2 className="mdetail-price">{FormatRupiah(produk.price)}</h2>
            </div>

            <h3 className="mdetail-desc-title">Deskripsi Produk</h3>
            <p className="mdetail-desc">
              {produk.description || "Deskripsi tidak tersedia"}
            </p>

            <button
              type="button"
              className={`btn-mdetail-cart${addedAnim ? " btn-mdetail-cart--added" : ""}`}
              onClick={() => handleAddToCart(produk)}
            >
              <i className={`bi ${inCart(produk?.id) ? "bi-cart-check-fill" : "bi-cart-plus"}`}></i>
              {inCart(produk?.id)
                ? `In Cart (${items.find((item) => item.id === produk.id)?.quantity || 0})`
                : "Tambah ke Keranjang"}
            </button>
          </div>
        </div>
      </div>

      {/* Floating Cart Button */}
      <button
        className="cart-float-btn"
        onClick={() => setShowCart(true)}
        title="Lihat Keranjang"
      >
        <i className="bi bi-bag"></i>
        {items.length > 0 && (
          <span className="cart-float-badge">{items.length}</span>
        )}
      </button>

      {/* Cart Popup */}
      {showCart && (
        <Cart
          emptyCart={emptyCart}
          onClose={() => setShowCart(false)}
        />
      )}

      <style>{`
        .cart-float-btn {
          position: fixed;
          bottom: 36px;
          right: 36px;
          z-index: 999;
          background: #e51d2a;
          color: white;
          border: none;
          border-radius: 50%;
          width: 60px;
          height: 60px;
          font-size: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 8px 25px rgba(229,29,42,0.35);
          cursor: pointer;
          transition: transform 0.3s, box-shadow 0.3s;
        }
        .cart-float-btn:hover {
          transform: scale(1.1);
          box-shadow: 0 12px 35px rgba(229,29,42,0.4);
        }
        .cart-float-badge {
          position: absolute;
          top: -4px;
          right: -4px;
          background: #111;
          color: white;
          border-radius: 50%;
          width: 22px;
          height: 22px;
          font-size: 12px;
          font-weight: 700;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .btn-mdetail-cart--added {
          transform: scale(0.96);
          opacity: 0.8;
        }
      `}</style>
    </section>
  );
};

export default MerchandiseDetail;
